import { createSelector } from "reselect";

const selectSlice = (state) => state.Phases || {};

export const selectPhases = createSelector(selectSlice, (s) => s.phases || []);
export const selectPhasesLoading = createSelector(selectSlice, (s) => s.loading || false);
export const selectSelectedPhase = createSelector(selectSlice, (s) => s.selectedPhase || null);
